import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const remoteActionImpactLevelOptions = [
  'High',
  'Medium',
  'Low',
] as const;

export const remoteActionImpactLevelSchema = createEnumSchemaPreprocessor(
  z.enum(remoteActionImpactLevelOptions),
  remoteActionImpactLevelOptions
);

export type RemoteActionImpactLevel = z.infer<
  typeof remoteActionImpactLevelSchema
>;
